import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { parseYouTubeUrl, convertImage } from 'appSrc/utils';
import { Link } from 'react-router-dom';
import Like from 'appSrc/components/Like';
import TextTruncate from 'react-text-truncate';
import TagDisplay from 'appSrc/components/Tag/Display';
import { VideoPlayer } from 'appSrc/components/Shards';
import ShareGroup from 'appSrc/components/Share/Group';
import { UserAvatar, RightChevron, GridCard } from 'appSrc/components/UI';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import AspectRatio from 'react-aspect-ratio';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import style from './styles/style.module.css';

class ArticleCard extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            videoPlaying: false,
        };
    }
    trackShare = ( medium ) => {
        this.props.noteListShare( this.props.article.listid )
        .then( ( article ) => {
            var coverType = !!article.video_url ? 'video' : !!article.cover_image ? 'image' : 'none';
            Mixpanel.track( 'articleShared', {
                id: article.id,
                name: article.title,
                date_created: article.created_at,
                published: article.published,
                like_count: parseInt( article.likes ),
                // purchase_count: '?',
                view_count: parseInt( article.views ),
                search_count: article.searches,
                share_count: article.shares,
                cover_type: coverType,
                share_medium: medium,
                author: article.userid,
            } );
        } );
    }

    render() {
        const { article } = this.props;
        const { videoPlaying } = this.state;

        const author = article.author || {};
        const profession = ( author.profession || {} ).title;
        const category = article.interests.length > 0 ? article.interests[0] : {};
        const showCategory = category.interestid && !category.deactivated;
        const articleSlug = `/app/articles/${ article.id }/${ encodeForURI(article.title) }`;

        return (
            <GridCard className={ style.articleCard }
            style={ { ...this.props.style } }
            data-video-playing={ videoPlaying }
            data-hook='article-card'>
                <Link to={ articleSlug } className={ style.linkOverlay }></Link>
                <div className={ style.cardContent }>
                    <AspectRatio ratio='16/9'>
                        <div className={ style.imageWrapper } >
                            { article.video_url ?
                                <VideoPlayer
                                videoId={ parseYouTubeUrl( article.video_url ) }
                                onActivate={ () => {
                                    this.setState( { videoPlaying: true } );
                                } }
                                coverImage={ article.coverImage }
                                authorId={ article.userid }
                                attachmentType='article_cover_video' attachmentId={ article.id } />
                                :
                                <ListCoverImage videoId={ parseYouTubeUrl( article.video_url ) }
                                coverImage={ article.cover_image } />
                            }
                            { !videoPlaying &&
                                <div className={ style.articleInfo }>
                                    <div className={ style.articleTitle } title={ article.title }>{ article.title }</div>
                                    <div className={ style.tagsWrapper }>
                                        <TagDisplay tags={ article.tags } white />
                                    </div>
                                </div>
                            }
                        </div>
                    </AspectRatio>

                    <div className={ style.titleBarWrapper }>
                        <div className={ style.divider } />
                        <div className={ style.titleBar } data-hook='list-card-title-bar'>
                            <div>
                                { author &&
                                <Link to={ `/${ author.slug }` } className={ style.userIcon }>
                                    <UserAvatar src={ author.avatar } size={ 80 } />
                                </Link>
                                }
                            </div>
                            { showCategory &&
                                <div className={ style.listCategory }><Link to={ `/app/explore/${ category.slug }` }>{ category.interest }</Link></div>
                            }
                        </div>
                    </div>
                    <div className={ style.listRelations }>
                        <p className={ style.listAuthor }
                        title={ author.displayName }>
                            <Link to={ `/${ author.slug }` } >by <span className={ style.name }>{ author.displayName }</span>
                                { profession && ', ' }
                                { profession &&
                            <span title={ profession } className={ style.profession }>{ profession }</span>
                                }
                            </Link></p>
                    </div>
                    <div>
                        <div className={ style.detailsWrapper }>
                            <TextTruncate
                            line={ 4 }
                            text={ article.primary_text }
                            containerClassName={ style.description } />
                        </div>
                    </div>
                    <div className={ style.bottomLinks }>
                        <div className={ `${ style.iconWrapper }` }>
                            <div className={ style.shareIcons }>
                                { this.renderShareGroup( article ) }
                                <Like type='article' item={ article }
                                size={ 15 } style={ { marginLeft: '12px' } } />
                            </div>
                        </div>
                        <div className={ style.productsLink }>
                            <Link to={ articleSlug }>
                                SEE MORE <RightChevron size={ 12 } style={ { display: 'inline-block', verticalAlign: 'unset' } } />
                            </Link>
                        </div>
                    </div>
                </div>
            </GridCard>
        );
    }
    renderShareGroup = ( article ) => {
        const articleSlug = `/app/articles/${ article.id }/${ encodeForURI(article.title) }`;
        const shareImage = !!article.coverImage ? convertImage( article.coverImage ) : undefined;
        const shareUrl = window.location.host + articleSlug;
        const emailShareProps = {
            subject: 'Check out this article on Desire Co.',
            message: `Thought you might like this ${ article.title } article.`,
            url: shareUrl,
            title: article.title,
            image: shareImage,
            style: {
                height: '12px',
                margin: '0',
                color: 'white',
            },
        };
        const facebookShareProps = {
            url: shareUrl,
            style: {
                height: '12px',
                margin: '0',
                color: 'white',
            },
        };
        const twitterShareProps = {
            url: shareUrl,
            style: {
                height: '12px',
                margin: '0',
                color: 'white',
            },
        };
        return (
            <ShareGroup
            trackShare={ this.trackShare }
            emailProps={ emailShareProps }
            facebookProps={ facebookShareProps }
            twitterProps={ twitterShareProps }
            label={ null }/>
        );
    }
}
ArticleCard.propTypes = {
    article: PropTypes.object.isRequired,
};


const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
    };
};

export default connect( mapStateToProps )( ArticleCard );
